<template>
  <div class="app-page-container  row-flex">
    <div class=" app-body donotsell-body  row-flex-body">
      <h1 class="title">{{ this.$t("doNotSell.text1") }}</h1>
      <div class="row-flex-content">

        <div class="step-bar-bg  row-flex-left">
          <div class="step-bar">
            <div>{{ this.$t("doNotSell.text2") }}</div>
            <div>{{ this.$t("doNotSell.text3") }}</div>
            <div>{{ this.$t("doNotSell.text4") }}</div>
          </div>
        </div>

        <div class="row-flex-right">
          <div class="opt-option">
            <div class="option" v-for="(opt, idx) in optionList" :key="idx"
              :class="['option', opt.value === doNotSell ? 'option-selected' : '']"
              @click="() => doNotSell = opt.value">
              {{ opt.label }}
            </div>
          </div>
          <div class="description">{{ this.$t("doNotSell.text8") }}</div>
          <template v-if="doNotSell">
            <input class="mint-input email-input" type="text" v-model="email" placeholder="Email" />
            <input class="mint-input email-input" type="text" v-model="state" placeholder="State" />
          </template>

          <!-- <h3 class="text-danger">{{$t("forbiddenRequest.title")}}</h3>
      <p class="desc"> {{$t("forbiddenRequest.desc")}}  </p>-->
          <!-- 人机校验 -->
          <div id="g-recaptcha" class="g-recaptcha" data-sitekey="6Le_suQZAAAAADBbYsFKsD_DaiRrzfhVqzypfcet" />
          <button class="game-button primary" @click="submit">
            {{ this.$t("doNotSell.text7") }}
          </button>
        </div>
      </div>
    </div>
    <description></description>
    <footerBar @showLanguage="showLanguage"></footerBar>
  </div>
</template>
<script>
var reCaptchaResponse = "";
import footerBar from "../components/common/footer";
import description from "../components/common/description";
import { Toast } from "mint-ui";
// var moment = require("moment");
export default {
  data() {
    return {
      email: '',
      state: '',
      doNotSell: false,
      optionList: [
        { label: this.$t("doNotSell.text5"), value: true },
        { label: this.$t("doNotSell.text6"), value: false },
      ]
    };
  },
  components: { footerBar, description },
  mounted() {
    setTimeout(() => {
      this.init();
    }, 400);

    const _this = this;
    window.addEventListener(
      "pageshow",
      function () {
        _this.checkIsLogin();
      },
      { passive: false }
    );
    window.addEventListener(
      "visibilitychange",
      function () {
        if (document.visibilityState === "visible") {
          _this.checkIsLogin();
        }
      },
      {
        passive: false,
      }
    );
  },
  methods: {
    checkIsLogin() {
      if (!this.$store.state.aid && !this.$store.state.pin) {
        this.$router.push({ name: "Login", query: { f: "DoNotSell" } });
      }
    },
    showLanguage() {
      this.$emit('showLanguage')
    },
    submit() {
      const _this = this
      if (this.doNotSell) {
        if (!this.email) {
          Toast({
            message: 'Please enter the email address.',
          });
          return false;
        }
        if (!/^\w+([-+.]\w+)*@\w+([-.]\w+)*\.\w+([-.]\w+)*$/.test(this.email)) { // 国际邮箱正则
          Toast({
            message: 'Invalid email address.',
          })
          return false
        }
        if (!this.state.length) {
          Toast({
            message: 'Please enter the state.',
          });
          return false;
        }
      }
      //  人机校验
      if (!reCaptchaResponse.length && !this.$store.state.autoLogined) {
        Toast({
          message: this.$t("toast.follow"),
        });
        return false;
      }
      this.$axios({
        method: "post",
        url: "/privacy/donotsell/request",
        data: {
          mail: _this.email,
          state: _this.state,
          gameID: _this.$store.state.gameID,
          grecaptcha: reCaptchaResponse,
          ua: navigator.userAgent || '',
          pinToken: _this.$cookie.get("token"),
          doNotSell: _this.doNotSell,
        },
      })
        .then((res) => {
          if (res.status === 200 && res.data.c === 0) {
            reCaptchaResponse = "";
            Toast({
              message: 'Your request has been received, and we will contact you in due course. Thanks for your support!',
            });
            // this.$router.push("/Home");
            setTimeout(() => {
              this.$router.push("/Home");
            }, 2000)
          } else {
            Toast({
              message: res.data.d,
            });
          }
        })
        .catch(() => {
          Toast({
            message: "error",
          });
        });
    },
    init() {
      this.doNotSell = this.$store.state.doNotSell || false;
      if (this.$store.state.autoLogined) {
        return;
      }
      window.grecaptcha.render("g-recaptcha", {
        sitekey: "6Le_suQZAAAAADBbYsFKsD_DaiRrzfhVqzypfcet",
        callback: function (response) {
          reCaptchaResponse = response;
        },
      });
    },
  },
};
</script>
<style lang="less" scoped>
.donotsell-body {
  // padding: 0 0.3rem 3rem 0.3rem;
  box-sizing: border-box;
  background: #fff;
  min-height: 100%;
  width: 100%;
  text-align: left;
  max-width: 1020px;
  margin: 0 auto;

  .title {
    padding-top: 0.5rem;
    font-size: 0.53rem;
    font-weight: bold;
    margin-bottom: 0.42rem;
    // @media only screen 
    // and (min-device-width: 700px) 
    // and (max-device-width: 1024px) 
    // and (orientation: portrait) {
    //   margin-top: 2rem;
    // }
  }

  .notice-box {
    padding: 0.2rem;
    background-color: #fff3cd;
    border: 2px solid #feeeba;
    box-sizing: border-box;
    border-radius: 3px;
    color: #846305;
    font-size: 0.3rem;
  }

  .divide-line {
    width: 100%;
    margin: 0.4rem auto;
    border-top: 1px solid #9e9e9e;
  }

  .opt-option {
    width: 100%;
    height: 0.9rem;
    margin-bottom: 0.32rem;
    border: 1px solid #0482d0;
    border-radius: 0.25rem;
    display: flex;
    justify-content: space-between;
    align-items: center;
    overflow: hidden;

    .option {
      width: 50%;
      height: 100%;
      background: #fff;
      color: #0482d0;
      font-size: 0.42rem;
      line-height: 0.9rem;
      text-align: center;
      font-weight: bold;
    }

    .option-selected {
      background: #0482d0;
      color: #fff;
    }
  }

  .game-button {
    width: 100%;
  }
}

.step-bar-bg {
  background: #F1F1F1;
  border-radius: 0.32rem;
  padding: 0.42rem;
  margin-bottom: 0.42rem;

  .step-bar {
    // margin-top: 0.32rem;
    display: flex;
    width: 100%;
    flex-direction: column;

    &>div {
      flex: 1;
      border-left: 1px dashed #5D7FEF;
      position: relative;
      font-size: 0.3rem;
      padding: 0 0.2rem 0.5rem 0.42rem;

      &:last-child {
        border: none;
        padding-bottom: 0;
      }

      &::before {
        content: "";
        display: inline-block;
        width: 0.42rem;
        height: 0.42rem;
        border-radius: 100%;
        background: #5D7FEF;
        position: absolute;
        left: -0.22rem;
        text-align: center;
        color: #ffffff;
        line-height: 0.42rem;
      }
    }

    &>div:first-child {
      &::before {
        content: "1";
      }
    }

    &>div:nth-child(2) {
      &::before {
        content: "2";
      }
    }

    &>div:nth-child(3) {
      &::before {
        content: "3";
      }
    }
  }
}

// .step-bar {
//   margin-top: 0.8rem;
//   display: flex;
//   width: 100%;
//   flex-direction: column;
//   & > div {
//     flex: 1;
//     border-left: 1px dashed #ddd;
//     position: relative;
//     margin: 0.5rem 0;
//     font-size: 0.3rem;
//     padding: 0.2rem;
//     &::before {
//       content: "";
//       display: inline-block;
//       width: 0.3rem;
//       height: 0.3rem;
//       border-radius: 100%;
//       background: green;
//       position: absolute;
//       top: -0.8rem;
//       left: -0.15rem;
//     }
//   }
// }
p {
  text-indent: 2em;
  font-size: 0.3rem;
}

.description {
  font-size: 0.3rem;
  margin-bottom: 12px;
}

@media screen and (orientation: landscape) {
  .title {
    padding-top: 0 !important;

  }

}
</style>